module.exports = __webpack_public_path__ + "img/usericon.0cf9c1cc.jpg";